import { axios } from '@Root/API'

export const remove = (studyProgrammeId, venueActivityId ) => {
	return axios.delete(`course-session/${studyProgrammeId}/off-venue-activity/${venueActivityId}`)
}
